import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"
import { Card, CardBody } from "reactstrap"

class ClientProfileMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        const { isResponsive } = this.props;
        const { id, clientId } = this.props.match.params;
        const navItems = [
            {
                id: 'primary',
                label: 'Primary Contact',
                link: `/clients/profile/primary/${this.props.match.params.id}/${this.props.match.params.clientId}`
            },
            {
                id: 'secondary',
                label: 'Secondary Contact',
                link: `/clients/profile/secondary/${this.props.match.params.id}/${this.props.match.params.clientId}`
            },
            {
                id: 'faimily-info',
                label: 'Family Info',
                link: `/clients/profile/faimily-info/${this.props.match.params.id}/${this.props.match.params.clientId}`
            },
            {
                id: 'important-date',
                label: 'Important Dates',
                link: `/clients/profile/important-date/${this.props.match.params.id}/${this.props.match.params.clientId}`
            },
        ];
        const currentPath = this.props.location?.pathname;
        const activeItem = navItems.find(item => currentPath.startsWith(item.link)) || navItems[0];
        return (
            <React.Fragment>
                {isResponsive ? (
                    <>
                        <Card style={{marginBottom:10}}>
                            <CardBody>
                                <h6>Select Menu</h6>
                                <select
                                    className="form-select mb-3"
                                    value={activeItem.link}
                                    onChange={(e) => this.props.history.push(e.target.value)}
                                >
                                    {navItems.map(item => (
                                        <option key={item.id} value={item.link}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </CardBody>
                        </Card>

                    </>

                ) : (
                    <TabNavigation navItems={navItems} />
                )}



            </React.Fragment>
        )
    }
}
ClientProfileMenu.propTypes = {
    match: PropTypes.object,
    isResponsive: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object
}
export default withRouter(ClientProfileMenu)
